import { useState, useEffect } from "react";
import { useChoicesContext } from "react-admin";
import { useFormContext } from "react-hook-form";
import { Autocomplete, Box, CircularProgress, TextField } from "@mui/material";

const AutocompleteArray = ({ buildLabel, setValueName, setValueFormat }) => {
    const { selectedChoices, allChoices, isFetching } = useChoicesContext();
    const { setValue } = useFormContext();

    const [assigned, setAssigned] = useState([]);
    const [choices, setChoices] = useState([]);
    const [fetching, setFetching] = useState(true);

    useEffect(() => {
        if (!isFetching) {
            setAssigned(selectedChoices.map((s) => buildLabel(s)));
            setChoices(allChoices.map((s) => buildLabel(s)));
            setFetching(isFetching);
        }
    }, [isFetching]);

    return (
        (fetching && (
            <Box>
                <CircularProgress />
            </Box>
        )) ||
        (!fetching && (
            <Autocomplete
                multiple
                fullWidth
                defaultValue={assigned}
                onChange={(event, newValue) => {
                    setValue(setValueName, setValueFormat(newValue), { shouldDirty: true });
                }}
                options={choices}
                renderInput={(params) => <TextField {...params} />}
            />
        ))
    );
};

export default AutocompleteArray;
